<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo de Fornecedor</span>
          <vs-input
            size="large"
            class="w-full"
            name="tipoFornecedor"
            id="tipoFornecedor"
            v-model="formCadastro.tipoFornecedor"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Tipo de Fornecedor')"
            :danger="validateClass('Tipo de Fornecedor')"
            val-icon-danger="clear"
            icon="icon-user"
            icon-pack="feather"
            icon-no-border
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTipoFornecedor == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from '../../locale';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';

export default {
  props: {
    sideBar: {
      type: Boolean
    },
    dados: {
      type: Object
    }
  },

  watch: {
    dados() {
      this.preencheForm();
    },
  },

  data() {
    return {
      aguardeCadastro: false,
      formCadastro: {
        idTipoFornecedor: null,
        tipoFornecedor: null
      },
    };
  },

  methods: {
    preencheForm() {
      if (this.dados.idTipoFornecedor) {
        this.formCadastro.idTipoFornecedor = this.dados.idTipoFornecedor;
        this.formCadastro.tipoFornecedor = this.dados.tipoFornecedor;
      } else {
        this.resetForm();
      };
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      let action, method;
      if (!this.formCadastro.idTipoFornecedor) {
        action = 'adicionar-tipo-fornecedor';
        method = 'post';
      } else {
        action = `atualizar-tipo-fornecedor/${this.formCadastro.idTipoFornecedor}`;
        method = 'put';
      };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            [method]('fornecedor', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        };
      });
    },

    resetForm() {
      this.formCadastro = {
        idTipoFornecedor: null,
        tipoFornecedor: null
      };
    },

    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },

  mounted() {
    this.$validator.localize('ptBr', locale);
  },

  components: {
    BotaoSubmit
  }
};
</script>
<!------------ END SCRIPT ------------>
